import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel/textLabel';
import InfoIcon from '../infoIcon/infoIcon';
var Stepper = /*#__PURE__*/function (_React$PureComponent) {
  function Stepper() {
    var _this;
    _classCallCheck(this, Stepper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Stepper, [].concat(args));
    _defineProperty(_this, "renderSteps", function () {
      if (_typeof(_this.props.steps) === _typeof([])) {
        return _this.props.steps.map(function (step, idx) {
          var title = step.title,
            content = step.content,
            tooltipContent = step.tooltipContent;
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            "data-hook": "step",
            className: "step"
          }, /*#__PURE__*/React.createElement("div", {
            className: "title-wrapper"
          }, /*#__PURE__*/React.createElement(TextLabel, {
            dataHook: "title",
            className: "title",
            type: "T19",
            value: title
          }), tooltipContent ? /*#__PURE__*/React.createElement(InfoIcon, {
            dataHook: "title-tooltip",
            className: "tooltip",
            text: tooltipContent
          }) : null), /*#__PURE__*/React.createElement("div", {
            className: "content-wrapper"
          }, /*#__PURE__*/React.createElement("div", {
            className: "divider"
          }), /*#__PURE__*/React.createElement("div", {
            "data-hook": "content",
            className: "content"
          }, content)));
        });
      }
    });
    return _this;
  }
  _inherits(Stepper, _React$PureComponent);
  return _createClass(Stepper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        getClassName = _this$props.getClassName,
        dataHook = _this$props.dataHook;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName('control-stepper')
      }, this.renderSteps());
    }
  }]);
}(React.PureComponent);
Stepper.displayName = displayNames.STEPPER;
Stepper.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.element,
    tooltipContent: PropTypes.string
  })).isRequired
};
export default compose(Stepper);